import React from 'react'
import { FilterParam, FilterName } from '../FilterBar.types'
import { GenericFilterDropdown } from './GenericFilterDropdown'

interface UserDepartmentFilterDropdownProps {
  isNested?: boolean
}

export const UserDepartmentFilterDropdown: React.FC<
  UserDepartmentFilterDropdownProps
> = ({ isNested }) => {
  return (
    <GenericFilterDropdown
      filterParam={FilterParam.USER_DEPARTMENT}
      filterName={FilterName.USER_DEPARTMENT}
      valueKey="userDepartments"
      isNested={isNested}
    />
  )
}
